import { TextInput, Checkbox } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Box } from "../../Components/Utils/Box";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { BlogArticle } from "../../Models/Blog/BlogArticle";


export class ArticleEditContent extends Table
{
    constructor(article: BlogArticle)
    {
        super([], [
            ["Opcje", new Box(
                new PrimaryButton("Pokaż").OnClick(() => window.location.hash = `blog/${article.Url.value}`),
                new PrimaryButton("Edytuj").OnClick(() => window.location.hash = `blog/${article.Url.value}/edit`)
            )],
            // ["Id", article.Id],
            ["Url", new TextInput(article.Url).Placeholder("Url (ten w pasku przeglądarki)")],
            ["Widoczny na stronie", new Checkbox(article.Visible)],
            ["Tytuł", new TextInput(article.Title).Placeholder("")],
            ["Kategoria", new TextInput(article.Category).Placeholder("")],
            ["Pod tytułem", new TextInput(article.Subtitle).Placeholder("")],
            // ["Treść", new DescriptionEditor(article.Content)],
            // ["Obrazek", new SinglePictureEdit(article.Image)],
        ]);
    }
}
